import { createGlobalStyle } from "styled-components";

export default createGlobalStyle`
  :root {
    --nf-primary-base: 255,90,54;
    --nf-primary: rgb(var(--nf-primary-base));
    --nf-on-primary: #fff;

    --nf-secondary-base: 25,50,81;
    --nf-secondary: rgb(var(--nf-secondary-base));
    --nf-on-secondary: #fff;

    --nf-gray-200-base: 117,137,162;
    --nf-gray-200: rgb(var(--nf-gray-200-base));

    --nf-font-s: 14px;
    --nf-font-m: 16px;
    --nf-font-l: 24px;

    --nf-spacing-xs: 4px;
    --nf-spacing-s: 8px;
    --nf-spacing-m: 12px;
    --nf-spacing-l: 16px;
    --nf-spacing-xl: 24px;
  }
  *, *::before, *::after {
    box-sizing: border-box;
    
  }

  html, body {
    font-family: 'Open Sans', sans-serif;
    color: var(--nf-secondary);  
  }

`;
